import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CatalogueService} from 'src/app/modules/services/catalogue/catalogue.service';
import {MatTableDataSource} from '@angular/material/table';

@Component({
    selector: 'app-cat-clas-p-detail',
    templateUrl: './cat-clas-p-detail.component.html',
    styleUrls: ['./cat-clas-p-detail.component.css']
})
export class CatClasPDetailComponent implements OnInit {


    data2: any;
    dataSource2 = new MatTableDataSource<any>();
    label = 'general_information';
    readColumns2: String[] = [
        'attrNm',
        'dataType',
        'attrLen',
        'regDt',


    ];

    constructor(
        private catalogueService: CatalogueService,
        public dialogRef: MatDialogRef<CatClasPDetailComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit(): void {
        this.getGlobInfo();
    }

    getGlobInfo() {


        this.catalogueService
            .getDetailInfoP(this.data.cateId)
            .subscribe((response) => {
                this.data2 = response['payload'];


                this.loadDataSource2();

            });

    }

    loadDataSource2() {
        this.dataSource2.data = this.data2;
    }


}
